import { cva } from "class-variance-authority";

export const dropdownLabelVariants = cva("cursor-default text-sm font-semibold", {
  variants: {
    variant: {
      // Titles a group of items inside the menu, flush on its first row: it takes back the 4px the menu and its groups
      // leave between children.
      group: "-mb-1 p-2 text-neutral-10",
      // Heads the whole menu: spans the menu's padding with a divider below.
      header: "-mx-2 -mt-2 mb-1 border-b border-neutral-96 px-4 py-3 text-neutral-30",
    },
  },
  defaultVariants: {
    variant: "group",
  },
});
